// extracted by css-extract-rspack-plugin
export default {"cls1":"TopicMarketingPage-cls1_DAG","cls2":"TopicMarketingPage-cls2_tjr TopicMarketingPage-cls1_DAG"};